<template>
  <div class="cropper-component">
    <section>
      <img id="cropper-image" class="logo-extracadabra" :src="photo" />
    </section>

    <QFooter class="bg-black padding-0-15">
      <div class="margin-15-0">
        <QBtn color="white" text-color="primary" class="btn-navigation-half" :label="$t('ETAB.BUTTONS.@CANCEL')" no-caps @click="$emit('onClose')" />
        <QBtn color="secondary" class="btn-navigation-half" :label="$t('ETAB.BUTTONS.@USE')" no-caps @click="onSubmit" />
      </div>
    </QFooter>
  </div>
</template>

<script>
  import Cropper from "cropperjs";

  export default {
    props: {
      photo: { type: String, default: "" },
    },
    emits: ["onSubmit", "onClose"],
    data() {
      return {
        cropper: null,
      };
    },
    mounted() {
      this.addCropper();
    },
    methods: {
      addCropper() {
        const image = document.getElementById("cropper-image");
        this.cropper = new Cropper(image, {
          aspectRatio: 2.381,
          viewMode: 3,
          cropBoxResizable: false,
          minCropBoxWidth: window.innerWidth,
        });
      },
      onSubmit() {
        // quality is handled by camera plugin
        const quality = 1;
        // we limit the size of the picture for performance
        const cropperOptions = { height: 600 };

        const croppedImage = this.cropper.getCroppedCanvas(cropperOptions).toDataURL("image/jpeg", quality);
        this.$emit("onSubmit", croppedImage);
      },
    },
  };
</script>

<style lang="scss">
  .cropper-component {
    display: flex;
    align-items: center;
    justify-content: center;

    > section {
      max-width: 80% !important;
      img {
        max-width: 100%;
      }
    }
  }
</style>
